import AppHeader from "@/components/AppHeader";

export default {
  name: "master-approval",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
  },
  data() {
    return {
      companies: "",
      getCompanisEnd: false,
      approvals: [],
      searchEnd: false,
      selectedCompany: localStorage.company_id,
      selectedApprovalType: "attendance",
      approvalTypes: [
        {
          type: "attendance",
          name: "勤怠申請"
        },
        {
          type: "leave",
          name: "休暇申請"
        },
        {
          type: "overtime",
          name: "残業申請"
        }
      ]
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async search() {
      let data = {
        company_id: this.selectedCompany,
        approval_type: this.selectedApprovalType
      };
      let res = await this.$store
        .dispatch("GET_APPROVAL", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.approvals = res.approvals;
      this.searchEnd = true;
    },
    goMasterApprovalCompany(departmentId) {
      this.$router.push({
        path: `/master_approval/${this.selectedCompany}/${departmentId}/${this.selectedApprovalType}`
      });
    }
  }
};
